import React from 'react';
import style from '../canvas.scss';

// Scenes
import BasisModelScene from '../../../scenes/basicModel/basicModelScene';
import EngineScene from '../../../scenes/engine/engineScene';
import PaintworkScene from '../../../scenes/paintwork/paintworkScene';
import PackageScene from '../../../scenes/package/packageScene';
import InteriorScene from '../../../scenes/interior/interiorScene';
import BasicVehicleScene from '../../../scenes/basicVehicle/basicVehicleScene';
import OptionalEquipmentScene from '../../../scenes/optionalEquipment/optionalEquipmentScene';
import ConclusionScene from '../../../scenes/conclusion/conclusionScene';

export default function Selection(props) {

    function loadActiveStep(list, step) {
        switch (list[step].name) {
            case 'series':
                return <h1>Series</h1>;
            case 'basicModel':
                return <BasisModelScene />;
            case 'engine':
                return <EngineScene />;
            case 'paintwork':
                return <PaintworkScene />;
            case 'package':
                return <PackageScene />;
            case 'interior':
                return <InteriorScene />;
            case 'basicVehicle':
                return <BasicVehicleScene />;
            case 'optionalEquipment':
                return <OptionalEquipmentScene />;
            case 'conclusion':
                return <ConclusionScene />;
            default: return null;
        }
    }

    return (
        <div className={style.selection}>
            {loadActiveStep(props.stepList, props.activeStep)}
        </div>
    );
}
